import { isAfter } from 'date-fns';
import { LAW, LAW_Y } from '../pages/documents/groups';
import { LAW_PASSPORT } from '../pages/deputies/constants';

const LAW_MIN_DATE = new Date(2018, 8, 24);
const LEGISLATIVE_INITIATIVE = '0.2EZ6G.632Q0.';

const isLoadedDocument = doc => doc != null && typeof doc.then !== 'function';

const isLawDocGroup = docGroup => docGroup === LAW || docGroup === LAW_Y;

/** refLinks / passportDocuments: массив, MobX ObservableArray или одиночный объект. */
export const toRelationList = relation => {
	if (relation == null) return [];
	if (Array.isArray(relation)) return relation;
	if (typeof relation[Symbol.iterator] === 'function') return [...relation];
	return [relation];
};

export const getDocRefLinks = doc => {
	if (!doc?.refLinks) return [];
	const value = typeof doc.refLinks === 'function' ? doc.refLinks() : doc.refLinks;
	return toRelationList(value);
};

export const getPassportDocuments = doc => {
	if (!doc?.passportDocuments) return [];
	const value = typeof doc.passportDocuments === 'function' ? doc.passportDocuments() : doc.passportDocuments;
	return toRelationList(value);
};

const addUniqueDoc = (list, seen, doc) => {
	if (!doc?.id || seen.has(doc.id)) return;
	seen.add(doc.id);
	list.push(doc);
};

export const documentIncludeForDeputyInitiated = () => ({
	fields: ['id', 'name', 'year', 'date', 'freeNum', 'docGroup'],
	include: [
		{
			relation: 'refLinks',
			scope: {
				fields: ['id', 'childId', 'name'],
				include: [
					{
						relation: 'child',
						scope: {
							fields: ['id', 'name', 'year', 'date', 'freeNum', 'docGroup'],
						},
					},
				],
			},
		},
		{
			relation: 'passportDocuments',
			scope: {
				fields: ['id', 'name', 'year', 'date', 'freeNum', 'docGroup'],
			},
		},
	],
});

/** Законопроекты из RefCorresp: старый путь (refLink → ZI) и новый (сам паспорт SAZD). */
export const collectLawPassportsFromRefCorresp = refCorrespItems => {
	const seen = new Set();
	const lawPassports = [];

	for (const r of refCorrespItems) {
		if (!isLoadedDocument(r.document)) continue;
		const doc = r.document;
		const refLinks = getDocRefLinks(doc);

		if (doc.docGroup === LAW_PASSPORT) {
			if (refLinks.length > 0 && refLinks[0].child) {
				addUniqueDoc(lawPassports, seen, refLinks[0].child);
			} else {
				addUniqueDoc(lawPassports, seen, doc);
			}
			continue;
		}

		if (doc.docGroup === LEGISLATIVE_INITIATIVE) {
			addUniqueDoc(lawPassports, seen, doc);
		}
	}

	return lawPassports;
};

/** Принятые законы: refLink с паспорта (Delo) или passportDocuments (SAZD). */
export const collectLawsFromRefCorresp = (refCorrespItems, { lawLinkNameFilter } = {}) => {
	const seen = new Set();
	const laws = [];

	for (const r of refCorrespItems) {
		if (!isLoadedDocument(r.document)) continue;
		const doc = r.document;
		const refLinks = getDocRefLinks(doc);

		for (const refLink of refLinks) {
			const child = refLink.child;
			if (!child || !isLawDocGroup(child.docGroup)) continue;
			if (!isAfter(new Date(child.date), LAW_MIN_DATE)) continue;
			if (lawLinkNameFilter && !refLink.name?.includes(lawLinkNameFilter)) continue;
			addUniqueDoc(laws, seen, child);
		}

		if (doc.docGroup === LAW_PASSPORT) {
			const passportDocs = getPassportDocuments(doc);
			for (const lawDoc of passportDocs) {
				if (!isLawDocGroup(lawDoc.docGroup)) continue;
				if (!isAfter(new Date(lawDoc.date), LAW_MIN_DATE)) continue;
				addUniqueDoc(laws, seen, lawDoc);
			}
		}
	}

	return laws;
};
